import { DateTime } from "luxon";

import { UserRssLinkSettings } from "../types";

export const DEFAULT_RSS_LINK_SETTINGS: UserRssLinkSettings = {
  vanityId: "",
  isEnabled: false,
  minimumSchedulingBuffer: 0,
  platformOptions: [],
  platformPreference: "all",
  workingHours: [],
  workingHoursEnabled: false,
  timezone: DateTime.now().zone.name,
};
